export default {"src":"/_next/static/media/unincluded-icon.c022d88a.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};